import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import useDecode from "hooks/useDecode";
import useGetEconomicSheets from "services/recordSheets/useGetEconomicSheets";
import EntornoLaboral from "../Comun/EntornoLaboral";
import LoaderMin from "components/blocks/Loader/LoaderMin";
import { SheetPage, SheetHero, SheetPill, SheetSection, SheetGrid, SheetField, SheetHighlightRow, SheetHighlight, formatText, formatDate, formatCurrency, buildEntornoLaboralProps } from "../SheetLayout";

const ImsResumen: React.FC = () => {
  const params = useParams<{ detailId: string; id: string }>();
  const resumenIMSId = params.detailId?.split("__")[1];
  const prestacionId = params.id.split("_")[1];
  const { getImsSummary, dataEconomicSheet: d, loadingEconomicSheet, errorEconomicSheet } = useGetEconomicSheets();
  const userId = useDecode("token")?.extension_id;

  useEffect(() => { getImsSummary(userId, prestacionId, resumenIMSId); }, []);

  if (loadingEconomicSheet) return <section className="container"><LoaderMin /></section>;
  if (errorEconomicSheet) return <section className="container"><p className="loader-text">Lo sentimos, se ha producido un error.</p></section>;
  if (!d) return <section className="container"><p className="loader-text">No hay datos para mostrar.</p></section>;

  return (
    <SheetPage>
      <SheetHero
        title="IMS Resumen"
        icon="layers"
        pills={<>
          <SheetPill label="Código" value={formatText(d.codigoNumeracion)} />
          <SheetPill label="Etapa" value={formatText(d.imsEtapa)} />
        </>}
      />

      <SheetSection title="Detalle" icon="file-text">
        <SheetGrid cols={2}>
          <SheetField label="Código Numeración"  value={formatText(d.codigoNumeracion)} />
          <SheetField label="Etapa actual I.M.S." value={formatText(d.imsEtapa)} />
        </SheetGrid>
      </SheetSection>

      <SheetSection title="Primer Pago" icon="euro">
        <SheetGrid>
          <SheetField label="Fecha Primer Pago"    value={formatDate(d.fechaPago1)} />
          <SheetField label="Fecha Primer Ingreso" value={formatDate(d.fechaIngreso)} />
          <SheetField label="% Retención"          value={formatText(d.retencion)} />
        </SheetGrid>
        <SheetHighlightRow>
          <SheetHighlight label="1ª Cantidad Abonada (Bruto)"  value={formatCurrency(d.cantidadAbonada)}     variant="blue" />
          <SheetHighlight label="1ª Cantidad Abonada (Neto)"   value={formatCurrency(d.cantidadAbonadaNeto)} variant="green" />
        </SheetHighlightRow>
      </SheetSection>

      <SheetSection title="Segundo Pago" icon="euro">
        <SheetGrid>
          <SheetField label="Fecha Segundo Pago"    value={formatDate(d.fechaPago2)} />
          <SheetField label="Fecha Segundo Ingreso" value={formatDate(d.fechaIngreso2)} />
          <SheetField label="% Retención"           value={formatText(d.retencion2)} />
        </SheetGrid>
        <SheetHighlightRow>
          <SheetHighlight label="2ª Cantidad Abonada (Bruto)"  value={formatCurrency(d.cantidadAbonada2)}     variant="blue" />
          <SheetHighlight label="2ª Cantidad Abonada (Neto)"   value={formatCurrency(d.cantidadAbonadaNeto2)} variant="green" />
        </SheetHighlightRow>
      </SheetSection>

      <SheetSection title="Tercer Pago" icon="euro">
        <SheetGrid>
          <SheetField label="Fecha Tercer Pago"    value={formatDate(d.fechaPago3)} />
          <SheetField label="Fecha Tercer Ingreso" value={formatDate(d.fechaIngreso3)} />
          <SheetField label="% Retención"          value={formatText(d.retencion3)} />
        </SheetGrid>
        <SheetHighlightRow>
          <SheetHighlight label="3ª Cantidad Abonada (Bruto)"  value={formatCurrency(d.cantidadAbonada3)}     variant="blue" />
          <SheetHighlight label="3ª Cantidad Abonada (Neto)"   value={formatCurrency(d.cantidadAbonadaNeto3)} variant="green" />
        </SheetHighlightRow>
      </SheetSection>

      <SheetSection title="Viuda y Sepelio" icon="info">
        <SheetGrid cols={3}>
          <SheetField label="Fecha Pago Alzado Viuda"  value={formatDate(d.fechaIngresoViuda)} />
          <SheetField label="Gastos Sepelio"           value={formatCurrency(d.gastosSepelio)} />
          <SheetField label="Fecha Pago Sepelio"       value={formatDate(d.fechaIngresoSepelio)} />
        </SheetGrid>
      </SheetSection>

      {d.entornoLaboral && <EntornoLaboral {...buildEntornoLaboralProps(d)} />}
    </SheetPage>
  );
};

export default ImsResumen;
